import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from '../Slider.styles';
import NavChevron from '../NavChevron/NavChevron';

var NavButtons = function NavButtons(_ref) {
  var _ref$content = _ref.content,
      content = _ref$content === void 0 ? [] : _ref$content,
      goToSlide = _ref.goToSlide,
      currentIndex = _ref.currentIndex,
      size = _ref.size,
      dataTest = _ref['data-test'];
  var navButtons = content.map(function (slide, index) {
    var buttonIndex = index + 1;
    var isActiveButton = buttonIndex === currentIndex;
    var slidingFromDirection = buttonIndex < currentIndex ? 'left' : 'right';
    return /*#__PURE__*/React.createElement(Styled.NavButton, {
      tabIndex: -1 // eslint-disable-next-line react/no-array-index-key
      ,
      key: index,
      active: isActiveButton,
      onClick: function onClick(event) {
        return goToSlide(buttonIndex, slidingFromDirection, event);
      },
      size: size,
      "data-test": "".concat(dataTest, "-button-").concat(index)
    });
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, navButtons);
};

var Nav = function Nav(_ref2) {
  var _ref2$content = _ref2.content,
      content = _ref2$content === void 0 ? [] : _ref2$content,
      goToSlide = _ref2.goToSlide,
      currentIndex = _ref2.currentIndex,
      nextIndex = _ref2.nextIndex,
      previousIndex = _ref2.previousIndex,
      showChevrons = _ref2.showChevrons,
      showNavButtons = _ref2.showNavButtons,
      isInfiniteCycle = _ref2.isInfiniteCycle,
      size = _ref2.size,
      _ref2$navStyle = _ref2.navStyle,
      navStyle = _ref2$navStyle === void 0 ? 'default' : _ref2$navStyle,
      dataTest = _ref2['data-test'],
      className = _ref2.className;
  if (content.length < 2) return null;
  var chevronProps = {
    goToSlide: goToSlide,
    currentIndex: currentIndex,
    nextIndex: nextIndex,
    previousIndex: previousIndex,
    isInfiniteCycle: isInfiniteCycle,
    contentLength: content.length,
    display: showChevrons,
    size: size,
    navStyle: navStyle,
    'data-test': dataTest,
    className: "".concat(className, "-chevron")
  };
  var NavButtonsProps = {
    content: content,
    goToSlide: goToSlide,
    currentIndex: currentIndex,
    size: size,
    'data-test': dataTest
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, navStyle === 'default' && /*#__PURE__*/React.createElement(Styled.Nav, {
    "data-test": "".concat(dataTest),
    className: className
  }, /*#__PURE__*/React.createElement(NavChevron, _extends({}, chevronProps, {
    slidingFromDirection: "left",
    isPrevious: true
  })), showNavButtons && /*#__PURE__*/React.createElement(NavButtons, NavButtonsProps), /*#__PURE__*/React.createElement(NavChevron, _extends({}, chevronProps, {
    slidingFromDirection: "right"
  }))), navStyle === 'withSlideCount' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Styled.NavWithCountArrows, null, /*#__PURE__*/React.createElement(NavChevron, _extends({}, chevronProps, {
    slidingFromDirection: "left",
    isPrevious: true
  })), /*#__PURE__*/React.createElement(NavChevron, _extends({}, chevronProps, {
    slidingFromDirection: "right"
  }))), /*#__PURE__*/React.createElement(Styled.NavWithCountLabel, {
    className: "".concat(className, "-nav-count")
  }, currentIndex, " / ", content.length)));
};

Nav.displayName = 'Nav';
NavButtons.displayName = 'NavButtons';
Nav.propTypes = {
  content: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  goToSlide: PropTypes.func.isRequired,
  currentIndex: PropTypes.number.isRequired,
  nextIndex: PropTypes.number.isRequired,
  previousIndex: PropTypes.number.isRequired,
  isInfiniteCycle: PropTypes.bool.isRequired,
  showChevrons: PropTypes.bool.isRequired,
  navStyle: PropTypes.oneOf(['default', 'withSlideCount'])
};
export default Nav;
export { NavButtons };